import React from "react";
import { FaPercent } from "react-icons/fa";
import { TiMessages } from "react-icons/ti";
import { VscGraph } from "react-icons/vsc";
import { BiCheckDouble } from "react-icons/bi";
import Links from "../sub-components/Links";
const { PUBLIC_URL } = process.env;

const Feature5 = () => {

  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  return (
    
      <div>
        <section className="section main-banner" id="f5top">
          <video autoPlay muted loop id="bg-video">
            <source
              src={dashboard_Video}
              type="video/mp4"
            />
          </video>

          <div className="video-overlay header-text">
            <div className="caption">
              <h4 style={{ color: "#f5a425" }}>
                Automatic feedback right after the test{" "}
              </h4>
              <h6>
                Don’t keep your respondents waiting for their results.
                <br /> Decide which information to share with them
                automatically.
              </h6>

              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
              <br />
              {/* <div>
                <a style={{ fontSize: "16px", color: "white" }}>Learn more</a>
                <br />
                <GoArrowDown style={{ color: "white" }} />
              </div> */}
            </div>
          </div>
        </section>

        <section className="dark-bg">
          <div className="container-fluid dark-bg-sec">
            <div className="row f5sec1">
              <div className="col-lg-12 f5sec1head">
                <h4>You decide how it works</h4>
                <h2>Flexible, automated test grading</h2>
              </div>
              <div className="col-lg-4 f5sec1content">
                <img
                  src={`${PUBLIC_URL}/assets/testPortal/feedback-tp-sec1-1.webp`}
                  className="f5sec1img"
                  alt=""
                />
                <h3>Pass/Fail</h3>
                <p>
                  After submitting all their answers, respondents may receive a
                  simple Pass/Fail mark. Further information about their
                  performance may be added manually by the test owner.
                </p>
              </div>
              <div className="col-lg-4 f5sec1content">
                <img
                  src={`${PUBLIC_URL}/assets/testPortal/feedback-tp-sec1-2.webp`}
                  alt=""
                />
                <h3>Grades based on ranges</h3>
                <p>
                  Each respondent receives a grade based on the percentage of
                  their correct answers. The test owner has full control over
                  score ranges.
                </p>
              </div>
              <div className="col-lg-4 f5sec1content">
                <img
                  src={`${PUBLIC_URL}/assets/testPortal/feedback-tp-sec1-3.webp`}
                  alt=""
                />
                <h3>Feedback</h3>
                <p>
                  Our online test maker features automatic and two-step feedback
                  options. Automatic feedback requires no action from the test
                  owner after the assessment. Two-step feedback includes both
                  initial automatic results and a second set of feedback that is
                  released by the test owner. Let’s get started now! Sign up
                  free
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="light-bg">
          <div className="container-fluid light-bg-sec">
            <div className="f5sec2">
              <h4>Let’s get started now!</h4>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="img-bg">
          <div className="container-fluid img-bg-sec">
            <div className="row f5sec3">
              <div className="col-md-12 col-lg-6 f5sec3img">
                <article className="video-item">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/feedback-tp2.webp`}
                      alt=""
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_l_r.svg`}
                      alt=""
                      className="green_l_r"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_r_l.svg`}
                      alt=""
                      className="green_r_l"
                    />
                  </figure>
                </article>
              </div>

              <div className="col-lg-6 f5sec3content">
                <h3>Wide variety of personalized feedback options</h3>
                <p>
                  Our test creating software allows test owners to set automatic
                  feedback. This can be either a simple overview of the whole
                  test or a detailed review including answers to each of the
                  test questions.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="dark-bg2">
          <div className="container-fluid dark-bg2-sec">
            <div className="row f5sec4">
              <div className="col-lg-12 f5sec4head">
                <h2>Fully customizable test summary page</h2>
                <h4>
                  Decide what feedback your respondents receive automatically.
                </h4>
              </div>

              <div className="col-lg-12 f5sec4content">
                <div className="row">
                  <div className="col-lg-6">
                    <h3>
                      <span className="f5sec4icon">
                        <FaPercent />
                      </span>{" "}
                      Points or percentage{" "}
                    </h3>
                    <p>
                      Test summary page can display the percentage of correct
                      answers and/or the number of points earned.
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <h3>
                      <span className="f5sec4icon">
                        <TiMessages />
                      </span>{" "}
                      Feedback
                    </h3>
                    <p>
                      The response may include only a Pass/Fail mark.
                      Alternatively, test owners can choose to add more
                      information that is specific to each respondent to the
                      test summary page.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 f5sec4content">
                <div className="row">
                  <div className="col-lg-6">
                    <h3>
                      <span className="f5sec4icon">
                        <VscGraph />
                      </span>{" "}
                      Grade{" "}
                    </h3>
                    <p>
                      Respondents can automatically receive their grades upon
                      completion of the test.
                    </p>
                  </div>
                  <div className="col-lg-6">
                    {" "}
                    <h3>
                      <span className="f5sec4icon">
                        <BiCheckDouble />
                      </span>{" "}
                      Correct answers{" "}
                    </h3>
                    <p>
                      Upon completion of the test, respondents may receive
                      correct answers to all the questions included in the test.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="light-bg">
          <div className="container-fluid light-bg-sec ">
            <div className="row f5sec5">
              <div className="col-lg-5">
                <p className="p-bold">
                  Give your respondents one- or two-step feedback. Send solely
                  an automatic response or have the option to add additional
                  information from the test owner.
                </p>
              </div>
              <div className="col-lg-5">
                <p className="p-light">
                  Experience complete control over your online assessment thanks
                  to the cutting-edge features of NexTestify.
                </p>
              </div>

              <div className="col-lg-2">
                <div className="main-button">
                  <div className="scroll-to-section">
                    <a href="#section2">Contact us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="dark-bg">
          <div className="container-fluid dark-bg-sec">
            <div className="row f5sec6">
              <div className="col-lg-6">
                <div className="f5sec6content">
                  <h3>Need to change the rules after the test? No problem.</h3>
                  <p>
                    Sometimes rules have to change. NexTestify allows you to
                    easily adjust grading options to fit your needs. This is
                    possible even after your respondents have finished their
                    tests. New criteria will apply automatically.
                  </p>
                </div>
              </div>

              <div className="col-md-12 col-lg-6 f5sec6img">
                <article className="video-item">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/feedback-tp3.webp`}
                      alt=""
                      // className="background-image"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/purple_curve_bottom.svg`}
                      alt=""
                      className="purple_curve_bottom"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/yellow_curve_top.svg`}
                      alt=""
                      className="yellow_curve_top"
                    />
                  </figure>
                </article>
              </div>
            </div>
          </div>
        </section>

        <section className="img-bg">
          <div className="container-fluid img-bg-sec">
            <div className="row f5sec7">
              <div className="col-md-12 col-lg-6 f5sec7img">
                <article className="video-item">
                  <figure>
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/feedback-tp4.webp`}
                      alt=""
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/yellow.svg`}
                      alt=""
                      className="overlay-image1"
                    />

                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                      alt=""
                      className="overlay-image2"
                    />
                    <img
                      src={`${PUBLIC_URL}/assets/testPortal/green_big.svg`}
                      alt=""
                      className="overlay-image3"
                    />
                  </figure>
                </article>
              </div>

              <div className="col-lg-6 f5sec7content">
                <h3>Access advanced, detailed insights into your tests</h3>
                <p>
                  NexTestify allows you to dig deep into the test results and
                  analyze data on many levels to get actionable insights. Use
                  the information gathered to improve your operations.
                </p>
                <div className="main-button">
                  <div className="scroll-to-section">
                    <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Links />
      </div>
  
  );
};

export default Feature5;
